module.exports = __webpack_public_path__ + "static/media/profile4.d1a9dd2c.png";